module.exports = __webpack_public_path__ + "static/img/banner-20-q3-online-voucher-nc.bd3bc7a.jpg";